import { Action } from '@ngrx/store';
import { domiciliosappgrupos } from '../../models/domiciliosappgrupos.model'

export const CARGAR_GRUPOS = '[Domicilios Grupos] Cargar grupos';
export const CARGAR_GRUPOS_FAIL = '[Domicilios Grupos Fail] Cargar grupos fail';
export const CARGAR_GRUPOS_SUCCESS = '[Domicilios Grupos Success] Cargar grupos success';

export class CargarGruposActions implements Action {
  readonly type = CARGAR_GRUPOS;
}

export class CargarGruposFailActions implements Action {
  readonly type = CARGAR_GRUPOS_FAIL;

  constructor ( public payload: any ) {}
}

export class CargarGruposSuccessActions implements Action {
  readonly type = CARGAR_GRUPOS_SUCCESS;

  constructor ( public grupos : domiciliosappgrupos[] ){}
}

export type gruposAcciones = CargarGruposActions
                             | CargarGruposFailActions
                             | CargarGruposSuccessActions;





// WEBPACK FOOTER //
// ./src/store/actions/domiciliosappgrupos.actions.ts